import { useTheme as useKYCTheme } from '@kyc-ui/react'
import { Theme } from '@kyc-ui/react/styles'

const useTheme = () => useKYCTheme<Theme>()

export default useTheme
